import useTemplateInstance from "../../../hooks/useTemplateInstance";
import React, {useEffect, useMemo, useRef} from "react";
import useComponentSize from "@rehooks/component-size";
import DrawTemplate from "../../Template/DrawTemplate";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {getBoxSize} from "../../../../../utils";

const useStyles = makeStyles(theme => ({
    templateContainer: {
        position: 'absolute',
        '& .template-inner-container': {
            transition: 'transform 0.3s',
            transitionTimingFunction: 'ease-in'
        },
        '&.separate-from-background .template-inner-container': {
            boxShadow: '0px 3px 6px #00000029',
        }
    },
    templateOuterContainer: {
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: 0,
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        overflow: 'hidden',
        // Disable pull to refresh
        touchAction:  'none'
    }
}));

const TemplateContainer = ({children, ...props}) => {
    const classes = useStyles();
    const [state] = useTemplateInstance();

    const ref = useRef();
    const size = useComponentSize(ref);


    const [cSize, style, outerPos] = useMemo(() => {
        const horizontalPadding = 30;
        const verticalPadding = 10;
        const cSize = getBoxSize('fit-in', state.template.dimensions, {
            width: size.width - (horizontalPadding * 2),
            height: size.height - (verticalPadding * 2),
        });
        const outerPos = {
            x: cSize.x,
            y: cSize.y,
            width: size.width - (horizontalPadding * 2),
            height: size.height - (verticalPadding * 2),
        }

        const style = {
            width: cSize.width + 'px',
            height: cSize.height + 'px',
            left: cSize.x + horizontalPadding + 'px',
            top: cSize.y + verticalPadding + 'px',
        }
        return [cSize, style, outerPos]
    }, [size]);

    return <div className={classes.templateOuterContainer} ref={ref}>
        <div className={`${classes.templateContainer} ${props.zoomResource ? 'zoomed' : ''} ${state.template.separateFromBackground ? 'separate-from-background' : ''}`} style={style}>
            <DrawTemplate templateInstance={state} containerSize={cSize}
                            outerPosition={outerPos}
                          {...props} />
        </div>
        {children}
    </div>
}
export default TemplateContainer;